module.exports = __webpack_public_path__ + "static/img/sh_bg.a413fc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sh_bg.png
// module id = NwZI
// module chunks = 174